module.exports = __webpack_public_path__ + "static/media/so.9afbb93b.jpg";